// extracted by mini-css-extract-plugin
module.exports = {"content":"content___ireIC","pendingApprovalText":"pendingApprovalText___3jRyu","close":"close___2fqTi","invite":"invite___s8pNC","buttons":"buttons___2QM7D"};